import React from "react";
import SETTLEMENT1 from "../../../assets/images/settlement01.png";
import SETTLEMENT2 from "../../../assets/images/settlement02.png";
import SETTLEMENT3 from "../../../assets/images/settlement03.png";
import SETTLEMENT4 from "../../../assets/images/settlement04.png";

// /document-api?i=settlement-process
export default function SettlementProcess() {
  return (
    <>
      <h5 className="fw-bold">1. Initiate the Settlement API Request</h5>
      <p>
        To start the settlement process, you need to send an API request to our endpoint. 
        Send a <b>POST</b> request to <code>{`{{url}}/api/opay/v1.0/partner/withdrawals/hq`}</code> with the following parameters in the JSON body:
      </p>
      <ul>
        <li>
          <b>amount</b>: The specific amount to be withdrawn. Minimum
          300.00 THB (30,000.00 LAK via <code>{`/withdrawals/lak/hq`}</code>), and
          it must not exceed your available balance.
        </li>
        <li>
          <b>ref_no</b>: Your unique reference number for this withdrawal transaction.
        </li>
      </ul>
      <div className="w-100 rounded-3 px-3 py-3 my-3 bg-light">
        <pre className="mb-0"><code>{`{
    "amount": 300,
    "ref_no": "2200000000101"
}`}</code></pre>
      </div>

      <h5 className="fw-bold">2. Receive the API Response</h5>
      <p>
        Upon a successful request, the system will process the data and return a JSON response containing the transaction details, including a generated transaction ID and the exact order datetime.
      </p>
      <div className="w-100 rounded-3 px-3 py-3 my-3 bg-light">
        <pre className="mb-0"><code>{`{
    "status": {
        "code": "S-2000",
        "message": "Success"
    },
    "data": {
        "transaction_id": "00000000-0000-0000-0000-00000000000",
        "ref_no": "00000000001",
        "amount": "300.00",
        "currency": "THB",
        "order_datetime": "2026-05-26 22:23:11"
    }
}`}</code></pre>
      </div>

      <h5 className="fw-bold">3. Internal Review and Email Issuance</h5>
      <ul>
        <li>Our operational staff will receive the submitted request and thoroughly verify the transaction details.</li>
        <li>Once the review is passed, our staff will send a verification email (valid for 15 minutes) to your registered email address.</li>
      </ul>

     <h5 className="fw-bold">4. Customer Verification via Email</h5>
      <p>
        For security purposes, the settlement requires explicit authorization from the customer:
      </p>
      <ul>
        <li>The customer will receive the verification email in their inbox.</li>
        <li>They must open the email and click on the provided secure link to verify and confirm the settlement request.</li>
      </ul>
      <p className="text-danger fw-bold">
        * Note: The email address must be the primary email registered in the system, and Two-Factor Authentication (2FA) must be enabled.
      </p>
      <div className="px-3 py-2 bg-light rounded-3 mb-3">
        <ol className="mb-0">
          <li className="mb-2">
            Click <b>"Open Verification"</b> within the email to access the secure settlement verification page.
            <div><img alt="API" src={SETTLEMENT1} className="w-100 my-3" style={{ maxWidth: 700 }}/></div>
          </li>
          <li className="mb-2">
            Enter your system login credentials (email and password) correctly.
            <div><img alt="API" src={SETTLEMENT2} className="w-100 my-3" style={{ maxWidth: 700 }}/></div>
          </li>
          <li className="mb-2">
            Enter the destination <b>wallet number</b> where you wish to receive the funds.
            <div><img alt="API" src={SETTLEMENT3} className="w-100 my-3" style={{ maxWidth: 700 }}/></div>
          </li>
          <li className="mb-2">
            Input the correct <b>2FA (Two-Factor Authentication) code</b> associated with your specified email.
            <div><img alt="API" src={SETTLEMENT4} className="w-100 my-3" style={{ maxWidth: 700 }}/></div>
          </li>
          <li>
            Click <b>"Verify"</b> to finalize and complete the settlement verification process.
          </li>
        </ol>
      </div>
      
        
        
        
      <h5 className="fw-bold">5. Wallet Deduction and Status Update</h5>
      <ul>
        <li>The requested amount is reserved (deducted from your available balance) immediately when the request is accepted.</li>
        <li>After the customer completes the email verification, our staff verify the destination wallet and mark the settlement as "success".</li>
        <li>If the settlement is cancelled, the reserved amount is returned to your wallet.</li>
      </ul>

      <h5 className="fw-bold">6. Final Notification to Customer</h5>
      <p>
        After the process is fully completed, our staff will notify the customer regarding the successful outcome of their settlement. This notification will be sent through the customer's preferred communication channel to ensure they are fully informed.
      </p>
    </>
  );
}
